import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface ChatHeaderProps {
  title: string;
  onBack?: () => void;
  className?: string;
}

/**
 * ChatHeader - Header do chat com botão voltar e título
 *
 * Baseado no mockup:
 * - Seta de voltar à esquerda
 * - Título da conversa centralizado/à direita da seta
 */
export const ChatHeader = ({ title, onBack, className = '' }: ChatHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate('/chat');
    }
  };

  return (
    <header
      className={`
        flex items-center gap-4
        h-16
        px-4
        bg-[#242424]
        border-b border-[#333333]
        ${className}
      `}
    >
      <button
        onClick={handleBack}
        className="
          p-2 -ml-2
          text-white hover:text-[#F4CC04]
          rounded-lg hover:bg-white/5
          transition-colors duration-200
        "
        aria-label="Voltar"
      >
        <ArrowLeft size={20} />
      </button>

      <h1 className="text-white font-medium text-base truncate flex-1">
        {title}
      </h1>
    </header>
  );
};
